import React, { useEffect, useRef, useState } from "react";
import { Download, FileText, FileType2, Presentation, FileJson, ChevronDown } from "lucide-react";

export function ExportMenu({ onPDF, onWord, onPPT, onJSON }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    window.addEventListener("mousedown", handler);
    return () => window.removeEventListener("mousedown", handler);
  }, [open]);

  const pick = (fn) => () => { setOpen(false); fn(); };

  return (
    <div className="relative" ref={ref}>
      <button className="btn btn-secondary btn-sm" onClick={() => setOpen(o => !o)} data-testid="btn-export-menu">
        <Download size={12}/> Export <ChevronDown size={11}/>
      </button>
      {open && (
        <div
          className="absolute right-0 bottom-full mb-1 w-52 rounded-sm border border-[var(--border)] bg-white shadow-lg z-50"
          data-testid="export-menu-dropdown"
        >
          <button className="w-full flex items-center gap-2 px-3 py-2.5 text-xs hover:bg-[var(--surface)] text-zinc-800" onClick={pick(onPDF)} data-testid="btn-export-pdf">
            <FileType2 size={14} className="text-red-600"/> Download as PDF
          </button>
          <button className="w-full flex items-center gap-2 px-3 py-2.5 text-xs hover:bg-[var(--surface)] text-zinc-800 border-t border-[var(--border)]" onClick={pick(onWord)} data-testid="btn-export-word">
            <FileText size={14} className="text-blue-700"/> Download as Word
          </button>
          <button className="w-full flex items-center gap-2 px-3 py-2.5 text-xs hover:bg-[var(--surface)] text-zinc-800 border-t border-[var(--border)]" onClick={pick(onPPT)} data-testid="btn-export-ppt">
            <Presentation size={14} className="text-orange-600"/> Download as PowerPoint
          </button>
          <button className="w-full flex items-center gap-2 px-3 py-2.5 text-xs hover:bg-[var(--surface)] text-zinc-800 border-t border-[var(--border)]" onClick={pick(onJSON)} data-testid="btn-export-json">
            <FileJson size={14} className="text-zinc-600"/> Export JSON (backup)
          </button>
        </div>
      )}
    </div>
  );
}
